import { render } from "./FilterProgram.vue?vue&type=template&id=3e5d7302"
import script from "./FilterProgram.vue?vue&type=script&lang=js"
export * from "./FilterProgram.vue?vue&type=script&lang=js"
script.render = render

export default script